export const timelogConstants = {
  TIMELOG_LIST_REQUEST: 'TIMELOG_LIST_REQUEST',
  TIMELOG_LIST_SUCCESS: 'TIMELOG_LIST_SUCCESS',
  TIMELOG_LIST_FAILURE: 'TIMELOG_LIST_FAILURE',
  TIMELOG_LIST_CHANGED: 'TIMELOG_LIST_CHANGED',
  TIMELOG_LIST_PAGINATION: 'TIMELOG_LIST_PAGINATION',

};
